
import React from "react";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import PropTypes from "prop-types";

const getCheckedLeft = (checked, isUser) => {
  if (checked) return 22
  else if (isUser) return 32
  else return 30
}

const StyleSwitch = styled(Switch)(({ theme, checked, content, isUser }) => ({
  fontSize: 14,
  padding: 8,
  width: 110,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: content,
      position: "absolute",
      top: 17,
      transform: "translateY(-50%)",
      width: 50,
      height: 16,
      left: getCheckedLeft(checked, isUser),
      color: "#FFFFFF",


    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    color: checked ? "green" : "red",

    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: 0,
  },
  "& input": {
    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: 0,
  },
  "& .MuiTouchRipple-root": {
    position: checked ? "absolute" : "default",
    left: checked ? 0 : 12,
    top: 0,
  },
  "& .MuiSwitch-switchBase": {
    top: checked ? 9 : 0,
    left: checked ? 60 : 0,
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#0832DE",
  },
  "& .MuiSwitch-switchBase+ .MuiSwitch-track": {
    backgroundColor: checked ? "green" : "red",
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "green"
  }
}));

export default function CustomSwitch({ label, checked, onChange, isUser }) {
  let content
  if (isUser) {
    content = checked ? '"Active"' : '"Blocked"'
  } else {
    content = checked ? '"Active"' : '"Resolved"'
  }
  return <StyleSwitch {...label} checked={checked} onChange={onChange} isUser={isUser} content={content} />;
}

CustomSwitch.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
};
